import React, { useState, useEffect } from 'react'
import { ContentCenter } from './ContentCenter/ContentCenter.component'
import ContentFooter from '../TikTokMiddleScreen/ContentFooter/ContentFooter.component'
import { trackingEventCallAPI, createSession } from '../../../api/trackingSDK'
import { EventTrackingList } from '../../../api/const'
import {OauthAPIInstance} from '../../../api/app-api';
import { BINDING_CONFIRMED, BINDING_CREATED,BINDING_FAILED } from '../../../constant';
import {useHistory} from 'react-router-dom';

const isAB = true;

const TikTokMiddleScreen = ({bindingInfo, adsInfo}) => {
  const [initialized, setInitialized] = useState(false);
  const [sessionTracking, setSessionTracking] = useState('');
  const history = useHistory();

  const handleCreateSession = () => {
    let session = ''
    createSession(res => {
      if (res) {
        setSessionTracking(res)
        session = res;
      }
    })

    return session;
  }

  const sendEventTracking = (session, eventName) => {
    let event = isAB ? 'AB'+eventName : eventName;
    const eventId = EventTrackingList.specialLandingPage.eventId[event];
    console.log('eventId middle screen', eventId)
    const metaData = {
      binding_token: bindingInfo?.binding_token,
      app_id: bindingInfo?.app_id
    }
    trackingEventCallAPI(eventId, session, metaData)  
  }

  const handleEventTrackingClientRequest = () => {
    let session = handleCreateSession();
    sendEventTracking(session, 'clientRequest')
  }

  const getBindingData = async (bindingID) => {
    const resp = await OauthAPIInstance.getBinding(bindingID);
    if (resp.status === 200) {
        return await resp.json();
    }
    return null;
  }

  useEffect(() => {
    document.title = 'Liên kết tài khoản Zalopay';
    sendEventTracking(sessionTracking, 'renderUIComplete')
      const intervalId = window.setInterval(async () => {
        const resp = await getBindingData(bindingInfo?.binding_token);
        if (!resp) {
          history.replace('/binding/result', {
            status: BINDING_FAILED,
          });
          return
        }else if (resp.status !== BINDING_CREATED && resp.status !== BINDING_CONFIRMED) {
          history.replace('/binding/result', {
            status: resp.status,
          });
          return
        }
      }, 2000);
    return () => window.clearInterval(intervalId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!initialized) {
    setInitialized(true);
    handleEventTrackingClientRequest();
  }  

    return (
      <main>
        <ContentCenter bindingInfo={bindingInfo} adsInfo={adsInfo}/>
        <ContentFooter bindingInfo={bindingInfo} sessionTracking={sessionTracking} isAB={isAB}/>
      </main>
    )
}

export default TikTokMiddleScreen;
